window.toggler = (divId) => {
    $("#" + divId).toggle();
}
window.show_div = (divId) => {
    $("#" + divId).show();
}
